import { API_URL } from 'config';
import { store } from 'store.js';
import { aggiornaClienti, aggiornaContestazioni, caricamento } from 'features/bi/biSlice';
import axios from 'axios';

const API_CONTESTAZIONI_URL = `${API_URL}/bi/contestazioni/`;

const getContestazioni = async () => {
  store.dispatch(caricamento(true));

  const {
    auth: {
      currentUser: { pin, utente },
    },
  } = store.getState();

  try {
    const res = await axios.post(API_CONTESTAZIONI_URL, { utente, pin });
    const { successo = false, bi = [], clienti = [] } = res.data;

    if (!successo) throw new Error(JSON.stringify(res));

    store.dispatch(aggiornaContestazioni(bi));
    store.dispatch(aggiornaClienti(clienti));
    store.dispatch(caricamento(false));
  } catch (e) {
    // eslint-disable-next-line no-alert
    alert('Unable to load data');
    console.log(e);
  }
};

export { getContestazioni };
